import { render, staticRenderFns } from "./LastSales.vue?vue&type=template&id=5c090d5b"
import script from "./LastSales.vue?vue&type=script&lang=js"
export * from "./LastSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports